import { LitElement, css } from 'lit';
import { customElement } from 'lit/decorators.js';

import './pages/app-home';
import './components/header';
import './components/footer';
import './components/section';
import './components/quiero_probarlo';
import './styles/global.css';
import { router } from './router';

@customElement('app-index')
export class AppIndex extends LitElement {
  static styles = css`
    main {
      padding-top: 72px;
    }
  `;

  firstUpdated() {
    router.addEventListener('route-changed', () => {
      if ("startViewTransition" in document) {
        // Convertimos el callback en una función asíncrona
        (document as any).startViewTransition(async () => {
          this.requestUpdate();
          await this.updateComplete; // Garantiza que Lit termine de renderizar el DOM
        });
      }
      else {
        this.requestUpdate();
      }
    });
  }

  render() {
    // router config can be round in src/router.ts
    return router.render();
  }

}
